// extracted by mini-css-extract-plugin
export var container = "_cz-0";
export var icon = "_cz-1";
export var text = "_cz-2";